var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-container"},[_c(_vm.getComponent(_vm.report_type),{tag:"component",attrs:{"id":`current-report`,"survey_status":_vm.survey_status,"get_current_status":_vm.get_current_status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }